/* grasetiketten.de: gemeinsame Bausteine (window.GE), Etiketten-Konfigurator und Staffeltabelle auf der Produktseite */
(function () {
  'use strict';
  if (window.GE) return;
  document.documentElement.classList.add('ge-js');

  var IDX_KEY = 'ge-idx-v2';
  var TTL = 30 * 60 * 1000;
  var MAT = { g: 'Graspapier', b: 'BIOpaper', r: 'Recyclingpapier' };
  var MAT_ORDER = ['g', 'b', 'r'];
  var FORM = {
    rund: 'Rund', oval: 'Oval', rechteckig: 'Rechteckig', quadratisch: 'Quadratisch', Siegel: 'Siegel',
    Herzform: 'Herz', dreieckig: 'Dreieck', Rundbogen: 'Rundbogen', Plakette: 'Plakette'
  };
  var FORM_ORDER = ['rund', 'oval', 'rechteckig', 'quadratisch', 'Siegel', 'Herzform', 'dreieckig', 'Rundbogen', 'Plakette'];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var indexPromise = null;
  var moneyFmt = null;
  try { moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); } catch (e) { /* alter Browser */ }

  /* ---------- Hilfsfunktionen ---------- */
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function money(cents) {
    var v = (cents || 0) / 100;
    return moneyFmt ? moneyFmt.format(v) : v.toFixed(2).replace('.', ',') + ' €';
  }
  function sizeKey(s) {
    return String(s || '').replace(/Ø|⌀/g, '').replace(/mm/gi, '').replace(/\s+/g, '').replace(/,/g, '.').toLowerCase();
  }
  function parseSize(s) {
    var k = sizeKey(s);
    if (!k) return null;
    var main = k.split('/');
    var parts = main[0].split('x').map(num).filter(function (v) { return isFinite(v) && v > 0; });
    if (!parts.length) return null;
    return { w: parts[0], h: parts.length > 1 ? parts[1] : parts[0], strip: main[1] ? num(main[1]) : 0 };
  }
  function area(s) { var z = parseSize(s); return z ? z.w * z.h : 0; }
  function sizeLabel(s) {
    return String(s || '').replace(/\s+/g, ' ').replace(/\s*x\s*/g, ' × ').trim();
  }
  function sheetDims(b) {
    var z = b ? parseSize(b) : null;
    return z ? { W: z.w, H: z.h } : { W: 210, H: 297 };
  }
  function productUrl(h) { return ROOT + 'products/' + encodeURIComponent(h); }

  /* ---------- Index laden (collection.ge-index) ---------- */
  function fetchPage(p) {
    return fetch(ROOT + 'collections/all?view=ge-index&page=' + p, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function loadIndex() {
    if (indexPromise) return indexPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(IDX_KEY) || 'null');
      if (c && c.items && Date.now() - c.t < TTL) { indexPromise = Promise.resolve(c.items); return indexPromise; }
    } catch (e) { /* ohne Speicher weiter */ }
    indexPromise = fetchPage(1).then(function (first) {
      var jobs = [];
      for (var p = 2; p <= (first.pages || 1); p++) jobs.push(fetchPage(p));
      return Promise.all(jobs).then(function (pages) {
        var items = first.items.slice();
        pages.forEach(function (pg) { items = items.concat(pg.items); });
        try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { /* voll */ }
        return items;
      });
    });
    indexPromise.catch(function () { indexPromise = null; });
    return indexPromise;
  }

  /* ---------- Formen als SVG ---------- */
  function heartPath(w, h) {
    return 'M' + r2(w / 2) + ' ' + r2(h) + 'C' + r2(w * 0.18) + ' ' + r2(h * 0.78) + ' 0 ' + r2(h * 0.55) + ' 0 ' + r2(h * 0.3) +
      'C0 ' + r2(h * 0.1) + ' ' + r2(w * 0.14) + ' 0 ' + r2(w * 0.28) + ' 0' +
      'C' + r2(w * 0.4) + ' 0 ' + r2(w * 0.47) + ' ' + r2(h * 0.07) + ' ' + r2(w / 2) + ' ' + r2(h * 0.16) +
      'C' + r2(w * 0.53) + ' ' + r2(h * 0.07) + ' ' + r2(w * 0.6) + ' 0 ' + r2(w * 0.72) + ' 0' +
      'C' + r2(w * 0.86) + ' 0 ' + r2(w) + ' ' + r2(h * 0.1) + ' ' + r2(w) + ' ' + r2(h * 0.3) +
      'C' + r2(w) + ' ' + r2(h * 0.55) + ' ' + r2(w * 0.82) + ' ' + r2(h * 0.78) + ' ' + r2(w / 2) + ' ' + r2(h) + 'Z';
  }
  function shapeSvg(form, w, h, strip) {
    var rr;
    switch (form) {
      case 'rund': return '<circle cx="' + r2(w / 2) + '" cy="' + r2(h / 2) + '" r="' + r2(Math.min(w, h) / 2) + '"/>';
      case 'oval': return '<ellipse cx="' + r2(w / 2) + '" cy="' + r2(h / 2) + '" rx="' + r2(w / 2) + '" ry="' + r2(h / 2) + '"/>';
      case 'Herzform': return '<path d="' + heartPath(w, h) + '"/>';
      case 'dreieckig': return '<path d="M' + r2(w / 2) + ' 0L' + r2(w) + ' ' + r2(h) + 'L0 ' + r2(h) + 'Z"/>';
      case 'Rundbogen':
        rr = Math.min(w / 2, h);
        return '<path d="M0 ' + r2(h) + 'L0 ' + r2(rr) + 'A' + r2(w / 2) + ' ' + r2(rr) + ' 0 0 1 ' + r2(w) + ' ' + r2(rr) + 'L' + r2(w) + ' ' + r2(h) + 'Z"/>';
      case 'Plakette':
        rr = Math.min(w, h) * 0.18;
        return '<path d="M' + r2(rr) + ' 0H' + r2(w - rr) + 'A' + r2(rr) + ' ' + r2(rr) + ' 0 0 0 ' + r2(w) + ' ' + r2(rr) + 'V' + r2(h - rr) +
          'A' + r2(rr) + ' ' + r2(rr) + ' 0 0 0 ' + r2(w - rr) + ' ' + r2(h) + 'H' + r2(rr) + 'A' + r2(rr) + ' ' + r2(rr) + ' 0 0 0 0 ' + r2(h - rr) +
          'V' + r2(rr) + 'A' + r2(rr) + ' ' + r2(rr) + ' 0 0 0 ' + r2(rr) + ' 0Z"/>';
      case 'Siegel':
        var d = Math.min(w, h), sw = strip || d * 0.35;
        return '<circle cx="' + r2(w / 2) + '" cy="' + r2(d / 2) + '" r="' + r2(d / 2) + '"/>' +
          (h > d ? '<rect x="' + r2(w / 2 - sw / 2) + '" y="' + r2(d / 2) + '" width="' + r2(sw) + '" height="' + r2(h - d / 2) + '" rx="' + r2(sw * 0.2) + '"/>' : '');
      default:
        rr = Math.min(w, h) * (form === 'quadratisch' || form === 'rechteckig' ? 0.05 : 0.1);
        return '<rect width="' + r2(w) + '" height="' + r2(h) + '" rx="' + r2(rr) + '"/>';
    }
  }
  function iconSvg(form) {
    var map = { rund: [20, 20], oval: [24, 16], rechteckig: [24, 15], quadratisch: [19, 19], Siegel: [14, 22], Herzform: [21, 19], dreieckig: [22, 19], Rundbogen: [18, 22], Plakette: [23, 16] };
    var s = map[form] || [22, 16], w = s[0], h = s[1];
    var inner = shapeSvg(form, w, h, form === 'Siegel' ? 5 : 0);
    return '<svg viewBox="-2 -2 ' + (w + 4) + ' ' + (h + 4) + '" aria-hidden="true" focusable="false"><g class="ge-ico">' + inner + '</g></svg>';
  }

  /* ---------- Bogenvorschau ---------- */
  function grid(w, h, n, W, H) {
    var best = null;
    for (var rot = 0; rot < 2; rot++) {
      var a = rot ? h : w, b = rot ? w : h;
      for (var c = 1; c <= n; c++) {
        if (n % c) continue;
        var r = n / c;
        if (c * a <= W + 0.01 && r * b <= H + 0.01) {
          var gx = (W - c * a) / (c + 1), gy = (H - r * b) / (r + 1);
          var score = Math.abs(gx - gy) + (rot ? 4 : 0);
          if (!best || score < best.score) best = { score: score, c: c, r: r, rot: rot, a: a, b: b, gx: gx, gy: gy };
        }
      }
    }
    if (best) return best;
    var c2 = Math.max(1, Math.floor(W / w)), r3 = Math.max(1, Math.ceil(n / c2));
    return { c: c2, r: r3, rot: 0, a: w, b: h, gx: Math.max(0, (W - c2 * w) / (c2 + 1)), gy: Math.max(0, (H - r3 * h) / (r3 + 1)) };
  }
  /* opts: { b: Bogenformat, pattern: true (leichtgewichtig fuer Vorschaukarten), id: eindeutige ID, label: aria-Text } */
  function sheetSvg(form, size, n, mat, opts) {
    opts = opts || {};
    var z = parseSize(size);
    if (!z || !n) return '';
    var dims = sheetDims(opts.b), W = dims.W, H = dims.H;
    var g = grid(z.w, z.h, n, W, H), out = '';
    var one = shapeSvg(form, z.w, z.h, z.strip);
    var cell = g.rot ? '<g transform="translate(' + r2(g.a) + ' 0) rotate(90)">' + one + '</g>' : one;
    if (opts.pattern) {
      var id = 'gep-' + (opts.id || Math.random().toString(36).slice(2, 8));
      var full = Math.floor(n / g.c), rest = n - full * g.c;
      var pw = g.a + g.gx, ph = g.b + g.gy;
      out = '<defs><pattern id="' + id + '" patternUnits="userSpaceOnUse" x="' + r2(g.gx) + '" y="' + r2(g.gy) + '" width="' + r2(pw) + '" height="' + r2(ph) + '">' + cell + '</pattern></defs>';
      if (full > 0) out += '<rect x="' + r2(g.gx) + '" y="' + r2(g.gy) + '" width="' + r2(g.c * pw - g.gx) + '" height="' + r2(full * ph - g.gy) + '" fill="url(#' + id + ')" stroke="none"/>';
      if (rest > 0) out += '<rect x="' + r2(g.gx) + '" y="' + r2(g.gy + full * ph) + '" width="' + r2(rest * pw - g.gx) + '" height="' + r2(g.b) + '" fill="url(#' + id + ')" stroke="none"/>';
    } else {
      var k = 0;
      for (var rr = 0; rr < g.r; rr++) {
        for (var cc = 0; cc < g.c; cc++) {
          if (k++ >= n) break;
          var x = g.gx + cc * (g.a + g.gx), y = g.gy + rr * (g.b + g.gy);
          out += '<g transform="translate(' + r2(x) + ' ' + r2(y) + ')">' + cell + '</g>';
        }
      }
    }
    var label = opts.label || ('Bogenvorschau: ' + sizeLabel(size) + ', ' + n + ' Etiketten pro Bogen');
    var a11y = opts.decorative ? 'aria-hidden="true" focusable="false"' : 'role="img" aria-label="' + esc(label) + '"';
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" ' + a11y + '>' +
      '<rect class="ge-sheet__bg" x="0.5" y="0.5" width="' + (W - 1) + '" height="' + (H - 1) + '" rx="' + r2(W / 52) + '"/>' +
      '<g class="ge-lb ge-lb--' + esc(mat || 'g') + '">' + out + '</g></svg>';
  }
  function renderSheet(fig, form, size, n, mat, b) {
    if (!fig) return;
    var svg = sheetSvg(form, size, n, mat, { b: b });
    if (!svg) return;
    var cap = fig.querySelector('figcaption');
    var holder = fig.querySelector('.ge-sheet__svg');
    if (!holder) { holder = document.createElement('div'); holder.className = 'ge-sheet__svg'; fig.insertBefore(holder, cap); }
    holder.innerHTML = svg;
    if (cap) cap.textContent = n + ' pro Bogen, schematisch';
  }

  window.GE = {
    MAT: MAT, MAT_ORDER: MAT_ORDER, FORM: FORM, FORM_ORDER: FORM_ORDER, ROOT: ROOT,
    num: num, esc: esc, money: money, sizeKey: sizeKey, parseSize: parseSize, area: area, sizeLabel: sizeLabel,
    productUrl: productUrl, loadIndex: loadIndex, shapeSvg: shapeSvg, iconSvg: iconSvg, grid: grid,
    sheetSvg: sheetSvg, renderSheet: renderSheet
  };

  /* ---------- Produktseite: Auswahl aufbauen ---------- */
  function bestMatch(list, curArea) {
    var best = null, bs = Infinity;
    list.forEach(function (it) {
      var a = area(it.s) || 1;
      var s = Math.abs(Math.log(a / (curArea || 1))) + (it.lz === '1-3' ? 0 : 0.05);
      if (s < bs) { bs = s; best = it; }
    });
    return best;
  }
  function build(el, cur, all) {
    /* Nur DIN-A4-Formate verknuepfen (Artikel auf kleinen Boegen haben eigene Packungen) */
    var items = all.filter(function (i) { return !i.b; });
    var sameMat = items.filter(function (i) { return i.m === cur.m; });
    var curArea = area(cur.s);
    var curKey = sizeKey(cur.s);

    /* 1 Form */
    var forms = {};
    sameMat.forEach(function (i) { (forms[i.f] = forms[i.f] || []).push(i); });
    var html = '';
    FORM_ORDER.concat(Object.keys(forms).filter(function (f) { return FORM_ORDER.indexOf(f) < 0; })).forEach(function (f) {
      if (!forms[f]) return;
      var active = f === cur.f;
      var target = active ? null : bestMatch(forms[f], curArea);
      var label = FORM[f] || f;
      html += active
        ? '<span class="ge-shape is-active" aria-current="true">' + iconSvg(f) + '<span>' + esc(label) + '</span></span>'
        : '<a class="ge-shape" href="' + productUrl(target.h) + '">' + iconSvg(f) + '<span>' + esc(label) + '</span></a>';
    });
    var slotF = el.querySelector('[data-ge-slot="form"]');
    if (slotF && html) slotF.innerHTML = html;
    var vF = el.querySelector('[data-ge-val="form"]');
    if (vF) vF.textContent = FORM[cur.f] || cur.f;

    /* 2 Format */
    var list = (forms[cur.f] || []).slice().sort(function (a, b) { return area(a.s) - area(b.s) || a.n - b.n; });
    var slotS = el.querySelector('[data-ge-slot="format"]');
    if (slotS && list.length) {
      var opts = list.map(function (i) {
        var txt = sizeLabel(i.s) + ', ' + i.n + ' pro Bogen' + (i.lz ? ', ' + i.lz + ' Werktage' : '');
        return '<option value="' + esc(i.h) + '"' + (i.h === cur.h ? ' selected' : '') + '>' + esc(txt) + '</option>';
      }).join('');
      var finder = el.getAttribute('data-finder');
      slotS.innerHTML = '<label class="ge-vh" for="ge-fmt-' + esc(cur.h) + '">Format wählen</label>' +
        '<div class="ge-selectwrap"><select class="ge-select" id="ge-fmt-' + esc(cur.h) + '">' + opts + '</select></div>' +
        '<p class="ge-hint">' + list.length + ' Formate in dieser Form' +
        (finder ? ', <a href="' + esc(finder) + '?form=' + encodeURIComponent(cur.f) + '&amp;m=' + encodeURIComponent(cur.m) + '">im Etiketten-Finder vergleichen</a>' : '') + '</p>';
      slotS.querySelector('select').addEventListener('change', function (e) {
        if (e.target.value && e.target.value !== cur.h) window.location.href = productUrl(e.target.value);
      });
    }

    /* 3 Material */
    var slotM = el.querySelector('[data-ge-slot="material"]');
    if (slotM) {
      var mh = '';
      MAT_ORDER.forEach(function (m) {
        var hit = null;
        if (m === cur.m) hit = { h: cur.h };
        else items.some(function (i) { if (i.m === m && i.f === cur.f && sizeKey(i.s) === curKey) { hit = i; return true; } return false; });
        var sw = '<span class="ge-mat__sw ge-mat__sw--' + m + '" aria-hidden="true"></span>';
        if (m === cur.m) mh += '<span class="ge-mat is-active" aria-current="true">' + sw + MAT[m] + '</span>';
        else if (hit) mh += '<a class="ge-mat" href="' + productUrl(hit.h) + '">' + sw + MAT[m] + '</a>';
        else mh += '<span class="ge-mat is-off" title="In diesem Format nicht als ' + MAT[m] + ' lieferbar">' + sw + MAT[m] + '</span>';
      });
      slotM.innerHTML = mh;
    }
    el.classList.add('is-built');
  }

  function init(el) {
    if (el.getAttribute('data-ready')) return;
    el.setAttribute('data-ready', '1');
    var cur = { h: el.dataset.handle, m: el.dataset.m, f: el.dataset.f, s: el.dataset.s, n: parseInt(el.dataset.n, 10) || 0 };
    renderSheet(el.querySelector('[data-ge-slot="sheet"]'), cur.f, cur.s, cur.n, cur.m);
    loadIndex().then(function (items) { build(el, cur, items); }).catch(function () { /* Textfassung bleibt stehen */ });
  }
  function scan() {
    var els = document.querySelectorAll('[data-ge-config]:not([data-ready])');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  /* ---------- Staffeltabelle mit der Variantenauswahl des Themes verbinden ---------- */
  function cssq(v) { return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('ge-tier__input')) return;
    var fs = t.closest('[data-ge-tiers]');
    if (!fs) return;
    var name = fs.getAttribute('data-pack-name'), pos = fs.getAttribute('data-pack-pos');
    var scope = t.closest('product-info') || document;
    var vs = scope.querySelector('variant-selects');
    Array.prototype.forEach.call(fs.querySelectorAll('.ge-tier'), function (l) { l.classList.toggle('is-active', l.contains(t)); });
    if (!vs) return;
    /* Das Theme erzeugt die Namen per capture, daher mit Zeilenumbruch: vergleichen ohne Leerraum */
    var want = name + '-' + pos, radio = null;
    Array.prototype.some.call(vs.querySelectorAll('input[type="radio"]'), function (inp) {
      if (inp.name.trim() === want && inp.value === t.value) { radio = inp; return true; }
      return false;
    });
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var sel = vs.querySelector('select[name="options[' + cssq(name) + ']"]');
    if (sel) {
      sel.value = t.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Start und Neuaufbau nach Variantenwechsel ---------- */
  function start() {
    scan();
    document.dispatchEvent(new CustomEvent('ge:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* PUB_SUB_EVENTS ist eine globale const aus pubsub.js (kein window-Property) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(scan, 0); });
  }
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var a = ms[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var n = a[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-ge-config') || (n.querySelector && n.querySelector('[data-ge-config]')))) { scan(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();